import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import $ from "jquery";
import BackBtn from "../../common/BackBtn";
import { DeleteIcon, HomeIcon } from "../../assets/Icons";
import TableSkelton from "../../skeltonloader/TableSkelton";
import NoDataFound from "../../common/NoDataFound";

class ListRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      List: [],
    };
  }

  componentDidMount() {
    $('[data-toggle="tooltip"]').tooltip();

    this.getList();
  }
  getList = () => {
    this.setState({ loading: true });
    var data = {
      sid: ud.main_id,
    };
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/ParentChildList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          if (response.data.listParentchild) {
            var r = _this.convert(response.data.listParentchild);
            _this.setState({ List: r, message: r.length === 0 ? "No Record Found." : "" });
          }
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.getList();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => this.setState({ loading: false }));
  };
  convert = (array) => {
    var map = {};
    for (var i = 0; i < array.length; i++) {
      var obj = array[i];
      obj.children = [];

      map[obj.id] = obj;

      var parent_id = obj.parent_id || "-";
      if (!map[parent_id]) {
        map[parent_id] = {
          children: [],
        };
      }
      map[parent_id].children.push(obj);
    }

    return map["-"].children;
  };

  createBank = () => {
    sessionStorage.setItem("p_c_bank_listtype", "parent");
    sessionStorage.removeItem("p_c_bank_listdata");
    window.location.href = "/create/parentchildbankcreate";
  };
  EditTask = (list) => {
    sessionStorage.setItem("p_c_bank_listtype", "child");
    sessionStorage.setItem("p_c_bank_listdata", JSON.stringify(list));
    window.location.href = "/create/parentchildbankcreate";
  };

  render() {
    const { errors } = this.state;
    return (
      <div>
        <div class="xp-breadcrumbbar">
          <div class="row">
            <div class="col-md-12 col-lg-12 my-3">
              <h4 class="xp-page-title">Question Hierarchy</h4>
            </div>
            <div class="col-md-10 col-lg-10">
              <div class="xp-breadcrumb gradient-border mt-0">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <i>
                        <HomeIcon />
                      </i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    Parent child list
                  </li>
                </ol>
              </div>
            </div>
            <div class="col-md-2 col-lg-2 text-right">
              <button className="btn btn-white rounded btn-lg p-11" title="Create New" onClick={this.createBank}>
                <i className="mdi mdi-plus mr-2"></i>Create New
              </button>
            </div>
          </div>
        </div>
        <div class="xp-contentbar p-30">
          <div class="row">
            <div class="col-lg-12">
              <div class="card document_gradient_border padding-0 m-b-30">
                <div class="card-header dv-center space-between border-radius-top-15">
                  <h5 class="card-title mb-0">Question Hierarchy List</h5>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    {/* {this.state.List.length === 0 ? (
                      this.state.message === "" ? (
                        // loader
                        <div className="lds-spinner">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      ) : (
                        // loader-end
                        <div className="message-no-record"> {this.state.message} </div>
                      )
                    ) : null} */}
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: "5%" }}>
                            S.N.
                          </th>
                          <th>Question</th>
                          <th className="text-center" style={{ width: "15%" }}>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading ? (
                          <TableSkelton colCount={3} />
                        ) : this.state.List.length === 0 ? (
                          <tr>
                            <td colSpan={3}>
                              <NoDataFound headText={"No List Found"} />
                            </td>
                          </tr>
                        ) : (
                          // <tr>
                          //   <td colSpan="5" className="text-center py-5">
                          //     <NoDataFound headText={this.state.message || "No Record Found."} />
                          //   </td>
                          // </tr>
                          this.state.List.map((list, index) => (
                            <tr>
                              <td className="text-center">
                                <strong>{index + 1}.</strong>
                              </td>
                              <td>{list.question}</td>
                              <td className="text-center">
                                <div
                                  class="tabledit-toolbar btn-toolbar"
                                  style={{ margin: "0 auto", display: "block" }}
                                >
                                  <div class="btn-group btn-group-sm">
                                    <button
                                      type="button"
                                      title="Add"
                                      onClick={() => this.EditTask(list)}
                                      class=" btn  btn-primary"
                                    >
                                      <i className="mdi mdi-plus mr-2"></i>Add
                                    </button>
                                    {/* <button type="button" title="Delete" class="btn btn-info ml-2">
                                      <i>
                                        <DeleteIcon />
                                      </i>
                                    </button> */}
                                    {/* <button className="btn btn-secondary btn-xs" data-toggle="tooltip" title="Edit"> <i className="mdi mdi-pencil"></i></button>
                                                                <button className="btn btn-danger btn-xs" data-toggle="tooltip" title="Delete"> <i className="mdi mdi-trash-can-outline"></i></button> */}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ListRange;
